import type { Router } from 'vue-router'

import { resolvePermissionAccess } from '../router/permissionAccess'
import { readPermissionSnapshot } from '../router/permissionSnapshot'
import { HOME_ROUTE_NAME } from '../router/routeNames'

import { onContextSwitched } from '@/features/account'
import { resolveGetStartedLanding } from '@/features/global-surface'

/**
 * Summary → Get Started while the account is eligible (legacy `DefaultLayout.vue:208`). Only
 * Summary — any other screen is somewhere the user chose to be.
 */
export async function landOnGetStartedFromSummary(router: Router): Promise<void> {
  if (router.currentRoute.value.name !== HOME_ROUTE_NAME) return
  const landing = await resolveGetStartedLanding()
  // Re-read: the user may have navigated away while the preference was loading.
  if (landing && router.currentRoute.value.name === HOME_ROUTE_NAME) await router.replace(landing)
}

/**
 * The coordinator's `onReady`: re-check the already-resolved route after every successful
 * boot/retry, once hydrated RBAC exists.
 */
export async function revalidateBootRoute(router: Router): Promise<void> {
  const snapshot = readPermissionSnapshot()
  if (snapshot.status !== 'ready') return
  const target = resolvePermissionAccess(router.currentRoute.value, snapshot)
  if (target !== true) {
    await router.replace(target)
    return
  }
  await landOnGetStartedFromSummary(router)
}

/** A workspace/account switch is not a re-boot, so `onReady` never sees it — answer it here. */
export function installGetStartedSwitchLanding(router: Router): () => void {
  return onContextSwitched(() => {
    void landOnGetStartedFromSummary(router).catch((error: unknown) => {
      console.error('[shell] Get Started switch landing failed:', error)
    })
  })
}
